import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './Tabs.module.css';

export interface SelectButtonOption<T> {
  label: ReactNode;
  value: T;
  isError?: boolean;
}

export interface SelectButtonsProps<T> {
  options: SelectButtonOption<T>[];
  selected?: SelectButtonOption<T>;
  onChange: (value: T) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
  capitalize?: boolean;
  error?: string;
}

export const SelectButtons = <T,>({
  options,
  selected,
  onChange,
  className,
  label,
  disabled = false,
  capitalize = true,
  error,
}: SelectButtonsProps<T>) => {
  const handleClickOption = (option: SelectButtonOption<T>) => {
    onChange(option.value);
  };
  const resolveSelected = selected; //|| options[0];
  return (
    <div
      className={classNames(
        {
          'w-full': !className?.includes('w-'),
        },
        className,
      )}
    >
      {label && (
        <label
          className={classNames(
            'flex flex-row justify-between text-[10px] leading-[18px]',
            'font-[Inter] text-gray-900 text-opacity-[.64] uppercase font-medium',
          )}
        >
          {label}
        </label>
      )}

      <div
        className={classNames(
          'flex items-center bg-gray-100 rounded min-h-[36px] divide-x divide-gray-200',
        )}
      >
        {options.map(({ label, value, isError }, index) => (
          <div key={index} className="w-full flex items-center justify-center">
            <button
              type="button"
              onClick={() => handleClickOption({ label, value })}
              disabled={disabled}
              className={classNames(
                'mx-[2px] w-full min-h-[32px] rounded-sm',
                'font-[Inter] text-[14px] leading-[20px] transition-all duration-300',
                {
                  'bg-white border-[1px] border-blue-700': resolveSelected?.value === value,
                  'text-gray-600 hover:text-gray-900': resolveSelected?.value !== value,
                  capitalize: capitalize,
                  'border-red-500 border-[1px]': isError && resolveSelected?.value !== value,
                  [styles.jumpAnimation]: isError && resolveSelected?.value !== value,
                },
              )}
            >
              {label}
            </button>
          </div>
        ))}
      </div>
      {error && (
        <p className="mt-1 text-sm text-[12px] text-error-red">
          {error[0].toUpperCase() + error.substring(1)}
        </p>
      )}
    </div>
  );
};
